import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from 'framer-motion';
import ShipStationDemo from "./ShipStationDemo";
import VeeqoDemo from "./VeeqoDemo";
import { trackTabChange } from "../../../utils/analytics";

const InteractiveDemo = () => {
  const [searchParams] = useSearchParams();
  const platformParam = searchParams.get("platform");
  const [activeTab, setActiveTab] = useState(platformParam === "veeqo" ? "veeqo" : "shipstation");
  
  // Update state if query param changes
  useEffect(() => {
    if (platformParam === "veeqo") {
      setActiveTab("veeqo");
    } else if (platformParam === "shipstation") {
      setActiveTab("shipstation");
    }
  }, [platformParam]);

  return (
    <div id="demo" className="bg-gray-50 py-16 pt-[100px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Try it Out
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Use this interactive demo to see how CustomSync maps your Amazon customization data to {activeTab === "shipstation" ? "ShipStation" : "Veeqo"}.
          </p>
        </motion.div>

        {/* Single Card Container */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="bg-white rounded-lg shadow-lg overflow-hidden"
        >
          {/* Tab Selector */}
          <div className="border-b border-gray-200">
            <div className="flex justify-center p-1">
              <div className="flex">
                <button
                  onClick={() => {
                    setActiveTab("shipstation");
                    trackTabChange("shipstation");
                  }}
                  className={`px-6 py-3 rounded-md text-sm font-medium transition-colors ${
                    activeTab === "shipstation"
                      ? "bg-blue-600 text-white"
                      : "text-gray-600 hover:text-gray-900"
                  }`}
                >
                  ShipStation
                </button>
                <button
                  onClick={() => {
                    setActiveTab("veeqo");
                    trackTabChange("veeqo");
                  }}
                  className={`px-6 py-3 rounded-md text-sm font-medium transition-colors ${
                    activeTab === "veeqo"
                      ? "bg-blue-600 text-white"
                      : "text-gray-600 hover:text-gray-900"
                  }`}
                >
                  Veeqo
                </button>
              </div>
            </div>
          </div>

          {/* Demo Content */}
          <div className="p-6">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {activeTab === "shipstation" ? <ShipStationDemo /> : <VeeqoDemo />}
            </motion.div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default InteractiveDemo;
